/** @format */
import { css } from 'styled-components';

const baseStyles = () => css`
    padding-left: 0;

    h3 {
        display: inline;
        margin-right: 1.2rem;
        color: var(--colors-text-secondary);
    }

    .criteria-box {
        margin: 0 0.8rem 0.8rem 0;
    }
`;

export const styles = () => css`
    ${baseStyles()}
`;
